import { Printer } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PrintButton({ testid = "print-btn" }) {
  return (
    <Button variant="outline" size="sm" onClick={() => window.print()} data-testid={testid} className="no-print">
      <Printer className="h-4 w-4 mr-1" /> Imprimer
    </Button>
  );
}
